<div id="layout-wrapper">
    <!-- <app-topbar> </app-topbar> -->
    <app-sidebar></app-sidebar>
    <div class="main-content" [class.sidebar-expanded]="!isSidebarExpanded" [class.sidebar-collapsed]="isSidebarExpanded">
        <div class="page-content" [class.p-0]="shouldRemovePadding">
            <router-outlet></router-outlet>
        </div>
        <!-- <app-footer></app-footer> -->
    </div>
</div>